import apiRequest from './apiRequest';

const invoiceApi = {
    // Organization APIs
    async getAllOrganizations(token) {
        const url = '/api/v1/invoicing/organizations/all';
        return apiRequest(url, 'GET', token);
    },

    async getOrganization(id, token) {
        const url = `/api/v1/invoicing/organizations/${id}`;
        return apiRequest(url, 'GET', token);
    },

    async createOrganization(data, token) {
        const url = '/api/v1/invoicing/organizations';
        return apiRequest(url, 'POST', token, data);
    },

    async updateOrganization(id, data, token) {
        const url = `/api/v1/invoicing/organizations/${id}`;
        return apiRequest(url, 'PUT', token, data);
    },

    // Invoice APIs
    async createInvoice(data, token) {
        return apiRequest('/api/invoices', 'POST', token, data);
    },

    async updateInvoice(invoiceId, data, token) {
        return apiRequest(`/api/invoices/${invoiceId}`, 'PUT', token, data);
    },

    async getInvoiceById(invoiceId, token) {
        return apiRequest(`/api/invoices/${invoiceId}`, 'GET', token);
    },

    async getInvoiceByNumber(invoiceNumber, token) {
        return apiRequest(`/api/invoices/number/${invoiceNumber}`, 'GET', token);
    },

    async getInvoicesByAccountId(accountId, token, page = 0, size = 20, sortBy = 'createdAt', sortDirection = 'desc') {
        return apiRequest(`/api/invoices/account/${accountId}?page=${page}&size=${size}&sortBy=${sortBy}&sortDirection=${sortDirection}`, 'GET', token);
    },

    async getInvoicesByGstin(gstin, token, page = 0, size = 20) {
        return apiRequest(`/api/invoices/gstin/${gstin}?page=${page}&size=${size}`, 'GET', token);
    },

    async getInvoicesByAccountIdAndGstin(accountId, gstin, token, page = 0, size = 20) {
        return apiRequest(`/api/invoices/account/${accountId}/gstin/${gstin}?page=${page}&size=${size}`, 'GET', token);
    },

    async getInvoicesWithFilters(filterData, token) {
        return apiRequest('/api/invoices/filter', 'POST', token, filterData);
    },

    async getInvoicesByStatus(status, token, page = 0, size = 20) {
        return apiRequest(`/api/invoices/status/${status}?page=${page}&size=${size}`, 'GET', token);
    },

    async getInvoicesByDateRange(startDate, endDate, token, page = 0, size = 20) {
        return apiRequest(`/api/invoices/date-range?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`, 'GET', token);
    },

    async getOverdueInvoices(token) {
        return apiRequest('/api/invoices/overdue', 'GET', token);
    },

    async updateInvoiceStatus(invoiceId, status, token) {
        return apiRequest(`/api/invoices/${invoiceId}/status?status=${status}`, 'PATCH', token);
    },

    async deleteInvoice(invoiceId, token) {
        return apiRequest(`/api/invoices/${invoiceId}`, 'DELETE', token);
    },

    async countInvoicesByAccountId(accountId, token) {
        return apiRequest(`/api/invoices/account/${accountId}/count`, 'GET', token);
    },

    async generateInvoiceNumber(prefix = 'INV-', token) {
        return apiRequest(`/api/invoices/generate-number?prefix=${prefix}`, 'GET', token);
    },
};

export default invoiceApi;
